import { useState } from "react";

function ReviewSlide({ testimonial }) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            className={`review-slide-container ${isHovered ? "hovered" : ""}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {/* Content wrapper with relative positioning */}
            <div className="review-content-wrapper">
                <div className="review-txt">{testimonial.text}</div>
                <div className="reviewer-infos">
                    <div className="reviewer-name">{testimonial.name}</div>
                    <div className="reviewer-separator">•</div>
                    <div className="reviewer-elo">{testimonial.elo}</div>
                </div>
            </div>
        </div>
    );
}
function ReviewGroup({ testimonials }) {
    return (
        <>
            <div className="group">
                {testimonials.map((t, i) => (
                    <ReviewSlide key={i} testimonial={t} />
                ))}
            </div>
            <div className="group" aria-hidden>
                {testimonials.map((t, i) => (
                    <ReviewSlide key={i} testimonial={t} />
                ))}
            </div>
        </>
    );
}

function Carousel({ testimonials, style }) {
    return (
        <div className="carousel" style={style}>
            <ReviewGroup testimonials={testimonials} />
        </div>
    );
}

function ReviewSection() {
    const testimonials = [
        {
            text: "Oakmate is 🐐 for real—best $25 I've ever spent on chess analysis.",
            name: "Max P.",
            elo: "1380 Elo",
        },
        {
            text: "Accuracy estimator—just like Chess.com—showed I lose 20% in time trouble. Now I manage my clock better.",
            name: "Omar T.",
            elo: "1120 Elo",
        },
        {
            text: "Hands down my biggest workflow improvement in years. Reviewing games has never been this smooth.",
            name: "Zara L.",
            elo: "1490 Elo",
        },
        {
            text: "The move-comparison pane caught a missed win faster than Chess.com's premium review.",
            name: "Priya K.",
            elo: "1420 Elo",
        },
        {
            text: "Blunder highlights are instant—fixed my hanging knights and jumped from 900 to 1150.",
            name: "Liam R.",
            elo: "1150 Elo",
        },
        {
            text: "Puzzle drills from real mistakes—went from dropping queens to holding draws.",
            name: "Nadia Z.",
            elo: "1280 Elo",
        },
        {
            text: "Runs on my old laptop at depth-15 without crashing. Bullet-friendly!",
            name: "Jake W.",
            elo: "1240 Elo",
        },
        {
            text: "One-time $10 purchase—no subscription fees. Pure, premium analysis.",
            name: "Ethan L.",
            elo: "1320 Elo",
        },
        {
            text: "Retry feature is genius. Found a mate I missed under time pressure.",
            name: "Sophie L.",
            elo: "1470 Elo",
        },
        {
            text: "Opening stats shocked me (75% losses in Italian when I thought I cooked!).",
            name: "Diego S.",
            elo: "1350 Elo",
        },
        {
            text: "Plain-English feedback (“You pinned your own bishop”) finally makes engine chatter make sense.",
            name: "Emily G.",
            elo: "860 Elo",
        },
        {
            text: "Daily report: bishops are my worst blunder. Tactics focus cut them from 4 to 1 per game.",
            name: "Hana M.",
            elo: "1030 Elo",
        },
        {
            text: "Weakness diagnosis flagged my endgame—300 points down. Custom puzzles got me over 1500.",
            name: "Raj P.",
            elo: "1510 Elo",
        },
        {
            text: "My students love the retry option and Chess.com-style accuracy scores to track progress.",
            name: "Irina V.",
            elo: "2270 Elo (Coach)",
        },
        {
            text: "Time management graph: I play like a 600 under 10s. Eye-opening!",
            name: "Anya B.",
            elo: "1420 Elo",
        },
    ];

    return (
        <>
            <div className="section-title-container">
                <div className="section-title">
                    Loved by world-class chess players
                </div>
                <div className="section-subtitle">
                    Chess enthusiasts trust Oakmate to elevate their game
                </div>
            </div>
            <div className="review-section-wrapper">
                <Carousel
                    testimonials={testimonials.slice(0, 7)}
                    style={{ opacity: 0.7 }}
                />
                <Carousel testimonials={testimonials.slice(7, 15)} />
                <Carousel testimonials={testimonials.slice(0, 7)} />
                <Carousel testimonials={testimonials.slice(0, 7)} />
                <Carousel
                    testimonials={testimonials.slice(0, 7)}
                    style={{ opacity: 0.7 }}
                />
            </div>
        </>
    );
}

export default ReviewSection;
